<template>
	<v-container style="overflow: hidden;">
		<iframe
			:src="
				`https://metabase-new.sharechat.com/public/dashboard/2a6c97ff-417d-4c15-bb00-d7ceb51cc495?tsmnumber=${retailerId}&start_date=${date}&end_date=${date}`
			"
			title="My associates"
			class="iframe"
		></iframe>
	</v-container>
</template>

<script>
export default {
	name: "Associates",
	props: {
		date: {
			type: String,
			default: ""
		},
		retailerId: {
			type: String,
			default: ""
		}
	}
};
</script>
<style scoped lang="scss">
.iframe {
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 680px;
	top: -14em;
}
@media screen and (min-width: 600px) {
	.iframe {
		position: relative;
		width: 100%;
		height: 100%;
		min-height: 832px;
		top: -11.5em;
	}
}
</style>
